export default [
  {
    path: '/localities',
    name: 'localities-list',
    component: () => import('@/views/location/localities/Index.vue'),
    meta: {
      layout: 'vertical',
      requireLogin: true,
      pageTitle: 'Localités',
      pageDesc: 'Gestion professionnelle des localités pour la logistique. Liste complète des localités avec options de recherche, filtrage et actions en masse.',
      breadcrumb: [
        {
          text: 'Localités',
          active: true,
          ariaLabel: 'Fil d’Ariane : Localités',
        },
      ],
      aria: {
        role: 'main',
        label: 'Gestion des localités',
      },
      breadcrumbLabel: 'Localités',
      roles: ['admin', 'superadmin'],
    },
  },
  {
    path: '/localities/create',
    name: 'localities-add',
    component: () => import('@/views/location/localities/Create.vue'),
    meta: {
      layout: 'vertical',
      requireLogin: true,
      pageTitle: 'Ajouter une localité',
      pageDesc: 'Ajoutez une nouvelle localité à la base logistique. Utilisez la terminologie professionnelle et suivez les instructions d’accessibilité.',
      breadcrumb: [
        {
          text: 'Localités',
          to: { name: 'localities-list' },
          ariaLabel: 'Retour à la liste des localités',
        },
        {
          text: 'Ajouter',
          active: true,
          ariaLabel: 'Ajouter une localité',
        },
      ],
      aria: {
        role: 'form',
        label: 'Formulaire d’ajout de localité',
      },
      breadcrumbLabel: 'Ajouter une localité',
      roles: ['admin', 'superadmin'],
    },
  },
  {
    path: '/localities/edit/:id',
    name: 'localities-edit',
    component: () => import('@/views/location/localities/Edit.vue'),
    meta: {
      layout: 'vertical',
      requireLogin: true,
      pageTitle: 'Modifier une localité',
      pageDesc: 'Modifiez les informations d’une localité existante. Respectez les normes d’accessibilité et la terminologie logistique.',
      breadcrumb: [
        {
          text: 'Localités',
          to: { name: 'localities-list' },
          ariaLabel: 'Retour à la liste des localités',
        },
        {
          text: 'Modifier',
          active: true,
          ariaLabel: 'Modifier la localité',
        },
      ],
      aria: {
        role: 'form',
        label: 'Formulaire de modification de localité',
      },
      breadcrumbLabel: 'Modifier une localité',
      roles: ['admin', 'superadmin'],
    },
  },
  {
    path: '/localities/detail/:id',
    name: 'localities-detail',
    component: () => import('@/views/location/localities/Detail.vue'),
    meta: {
      layout: 'vertical',
      requireLogin: true,
      pageTitle: 'Détails de la localité',
      pageDesc: 'Consultez les informations détaillées d’une localité, y compris les commandes associées. Navigation accessible et terminologie professionnelle.',
      breadcrumb: [
        {
          text: 'Localités',
          to: { name: 'localities-list' },
          ariaLabel: 'Retour à la liste des localités',
        },
        {
          text: 'Détails',
          active: true,
          ariaLabel: 'Détails de la localité',
        },
      ],
      aria: {
        role: 'region',
        label: 'Détails de la localité',
      },
      breadcrumbLabel: 'Détails de la localité',
      roles: ['admin', 'superadmin'],
    },
  },
]
